<div class="card side-entity-card" [style.height]="containerHeight" [ngStyle]="componentColourStyles">

  <!-- Drag handle: resizes the form panel against the table widget -->
  <div class="panel-resize-handle"
       title="Drag to resize"
       (pointerdown)="onResizeHandlePointerDown($event)">
    <div class="panel-resize-grip"></div>
  </div>

  <div class="loading-overlay" *ngIf="loading || isSaving">
    <mat-spinner [diameter]="40"></mat-spinner>
  </div>

  <ng-container *ngIf="editableRecord; else noRecord">
    <div class="form-section form-section--main">
      <div class="section-header" (click)="data.sections[0].isExpanded = !data.sections[0].isExpanded">
        <span>{{ sectionTitle }}</span>
        <mat-icon>{{ data.sections[0].isExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
      </div>

      <div class="section-content" *ngIf="data.sections[0].isExpanded">
        <div *ngFor="let field of formFields" class="form-row">
          <label class="form-label">{{ field.label }}</label>

          <!-- Dropdown -->
          <div *ngIf="hasFieldDropdown(field.key)" class="domain-field-group">
            <mat-form-field appearance="outline" class="form-field domain-select-field">
              <mat-select
                panelClass="side-entity-domain-select-panel"
                [value]="getFieldSelectedValue(editableRecord[field.key])"
                [compareWith]="compareFieldDropdownValues"
                (openedChange)="onDomainSelectOpened(field.key, $event)"
                (selectionChange)="onFieldValueChange(field.key, $event.value)">
                <mat-select-trigger>
                  {{ getFieldDisplayLabel(field.key) || '--Select--' }}
                </mat-select-trigger>
                <mat-option class="domain-search-option" (click)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()">
                  <input
                    class="domain-search-input"
                    type="text"
                    placeholder="Search"
                    [value]="getFieldDropdownSearchTerm(field.key)"
                    (mousedown)="$event.stopPropagation()"
                    (click)="$event.stopPropagation()"
                    (keydown)="$event.stopPropagation()"
                    (keyup)="$event.stopPropagation()"
                    (input)="setFieldDropdownSearchTerm(field.key, $any($event.target).value)">
                </mat-option>
                <mat-option class="domain-placeholder-option" [value]="null">--Select--</mat-option>
                <mat-option *ngIf="fieldDropdownLoading[field.key]" disabled>Loading...</mat-option>
                <mat-option *ngFor="let option of getFilteredFieldDropdownOptions(field.key)" [value]="getFieldDropdownValue(option)">
                  {{ getFieldDropdownLabel(option) }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <button type="button" class="domain-action-button clear-domain-button" aria-label="Clear selection" matTooltip="Clear" (click)="clearFieldDropdown(field.key)">
              <mat-icon>close</mat-icon>
            </button>
            <button type="button" class="domain-action-button reference-domain-button" aria-label="Reference entity" [matTooltip]="getDomainReferenceTooltip(field.key)" matTooltipClass="side-entity-reference-tooltip" (click)="navigateToDomainReference(field.key)">
              <mat-icon>apps</mat-icon>
            </button>
          </div>

          <!-- Date picker -->
          <mat-form-field *ngIf="!hasFieldDropdown(field.key) && isDateField(field.key)" appearance="outline" class="form-field date-field">
            <input matInput [matDatepicker]="picker"
                   [value]="getDateValue(editableRecord[field.key])"
                   (dateInput)="onDateValueChange(field.key, $event.value)"
                   (dateChange)="onDateValueChange(field.key, $event.value)"
                   (input)="onDateInputMask(field.key, $event)"
                   inputmode="numeric"
                   maxlength="10"
                   placeholder="MM/DD/YYYY">
            <mat-datepicker-toggle matIconSuffix [for]="picker" class="date-toggle">
              <mat-icon matDatepickerToggleIcon>calendar_month</mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>

          <!-- Text input -->
          <mat-form-field *ngIf="!hasFieldDropdown(field.key) && !isDateField(field.key)" appearance="outline" class="form-field">
            <input matInput [ngModel]="formatFieldValue(editableRecord[field.key])" (ngModelChange)="onFieldValueChange(field.key, $event)">
          </mat-form-field>
        </div>
      </div>

      <div class="form-actions" *ngIf="data.sections[0].isExpanded">
        <hr class="divider" />
        <div class="action-buttons-container">
          <button
            *ngFor="let action of data.sections[0].actions"
            mat-flat-button
            [class]="action.style"
            (click)="handleAction(action.actionId)"
            [disabled]="isSaving">
            {{ action.label }}
          </button>
        </div>
      </div>
    </div>

    <div class="form-section" *ngIf="data.sections[1]">
      <div class="section-header" (click)="data.sections[1].isExpanded = !data.sections[1].isExpanded">
        <span>{{ data.sections[1].title }}</span>
        <mat-icon>{{ data.sections[1].isExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
      </div>
      <div class="section-content" *ngIf="data.sections[1].isExpanded">
        <p>Related entities content placeholder.</p>
      </div>
    </div>
  </ng-container>

  <ng-template #noRecord>
    <div *ngIf="!loading" class="no-record-message"></div>
  </ng-template>

</div>
